import styled from 'styled-components';

const Styleguide = styled.div`
  width: 100%;
`;

export { Styleguide };
